/**
 * Real phoenix asset — clean isolated illustration.
 * mixBlendMode: 'screen' removes the white background against our dark bg.
 */
const PHOENIX_SRC =
  "https://customer-assets-jt897jd0.emergentagent.net/job_why-recover-app/artifacts/4ewh7sj6_A5970477-FD73-4CDC-9A01-A0BE324087FD.png";

const PhoenixImage = ({ variant = "hero", size, className = "" }) => {
  const style =
    variant === "mark"
      ? { width: size || 40, height: size || 40, objectFit: "contain" }
      : { width: "100%", height: "auto", objectFit: "contain" };

  return (
    <img
      src={PHOENIX_SRC}
      alt="Phoenix"
      className={className}
      style={{
        ...style,
        mixBlendMode: "screen",
        filter: "brightness(1.05)",
      }}
      aria-hidden="true"
    />
  );
};

export default PhoenixImage;
